module.exports = __webpack_public_path__ + "img/thumbnail_Alpaca_m_normal.bb7c6089.png";